export default "__VITE_ASSET__CXNaNSRw__"